import { Stack, Typography } from "@mui/material";

const columns = [
  { field: "siteUuid", headerName: "شناسه", flex: 2 },
  { field: "siteName", headerName: "عنوان کسب‌وکار", flex: 2 },
  { field: "chain", headerName: "حلقه", flex: 1 },
  { field: "startDate", headerName: "شروع عضویت", flex: 1 },
  { field: "endDate", headerName: "پایان عضویت", flex: 1 },
];

function SiteTableMobile({ dataTable }) {
  return (
    <Stack width={320} borderRadius={2} gap={0.1}>
      {/* Header */}
      <Stack direction="row" bgcolor="#c6eff8" borderRadius={1} overflow="hidden">
        {columns.map((col) => (
          <Stack key={col.field} flex={col.flex} p={0.5} alignItems="center" justifyContent="center">
            <Typography variant="tiny" fontSize={6} fontWeight={500}>{col.headerName}</Typography>
          </Stack>
        ))}
      </Stack>

      {/* Rows */}
      {dataTable.map((row) => (
        <Stack key={row.id} direction="row" border="1px solid #E0E0E0" borderRadius={1} overflow="hidden">
          {columns.map((col) => (
            <Stack key={col.field} flex={col.flex} p={0.5} alignItems="center" justifyContent="center">
              <Typography variant="tiny" textAlign={"center"} fontSize={5}>
                {row[col.field]}
              </Typography>
            </Stack>
          ))}
        </Stack>
      ))}
    </Stack>
  );
}
export default SiteTableMobile;
